/** @type {import('../schema').ProcessDefinition} */
const cierreMes = {
  id: "cierre-mes",
  name: "Cierre de mes (gastos comunes)",
  category: "finanzas",
  outcome:
    "Repartir los gastos del mes entre las unidades y generar la deuda (payments) de cada residente, lista para revisión.",
  trigger: "El Administrador lo inicia manualmente desde la pantalla Cierre de mes.",
  actors: ["Administrador", "Sistema"],
  status: "COMPLETO",
  description:
    "Calcula y distribuye los gastos comunes del período por alícuota, superficie o partes iguales, prorratea por días si hubo cambio de ocupante, incorpora multas y cargos de amenities, y deja la cuenta mensual lista para aprobación.",
  lanes: [
    { id: "admin", actor: "Administrador" },
    { id: "sys", actor: "Sistema" },
  ],
  steps: [
    { id: "s1", laneId: "admin", type: "start", label: "Inicia el cierre del mes", description: "El admin abre Cierre de mes y dispara el cálculo del período.", evidence: "src/screens/admin/CierreMes.jsx:591" },
    { id: "s2", laneId: "sys", type: "task", label: "Pre-validación del cierre", description: "Verifica que el edificio tenga gastos del mes, unidades con alícuota/m² y que no exista un cierre duplicado.", evidence: "src/screens/admin/CierreMes.jsx" },
    { id: "s3", laneId: "sys", type: "decision", label: "¿Validación OK?", description: "Reporte de validación con críticas/advertencias." },
    { id: "sErr", laneId: "admin", type: "end", label: "Cierre cancelado", description: "Faltan alícuotas/m² o no hay gastos pagados; el admin corrige y reintenta." },
    { id: "s4", laneId: "sys", type: "task", label: "Selecciona gastos pagados del período", description: "Toma los gastos pagados con fecha de pago dentro del mes/año." },
    { id: "s5", laneId: "sys", type: "task", label: "Distribuye por unidad", description: "Según el criterio del gasto (propietario / inquilino / todos) y el método: alícuota ‰, superficie m² o partes iguales. Corrige el redondeo del centavo.", evidence: "src/utils/fundBalances.js" },
    { id: "s6", laneId: "sys", type: "decision", label: "¿Hubo cambio de ocupante?" },
    { id: "s7", laneId: "sys", type: "task", label: "Proración por días entre ocupantes", description: "Reparte el gasto común por los días que ocupó cada residente en el mes.", evidence: "src/utils/occupancies.js" },
    { id: "s8", laneId: "sys", type: "task", label: "Incluye multas activas y cargos de amenities", description: "Las multas activas y los cargos de amenities pendientes del mes se suman a la deuda del residente." },
    { id: "s9", laneId: "sys", type: "document", label: "Genera la deuda por residente", description: "Agrupa por (residente, unidad) y crea un payment con su desglose (breakdown).", evidence: "src/screens/admin/CierreMes.jsx:1118" },
    { id: "s10", laneId: "sys", type: "task", label: "Persistencia atómica", description: "Guarda en lotes y crea la cuenta mensual (montlyaccount), state: processing → ok." },
    { id: "s11", laneId: "admin", type: "end", label: "Pendiente de aprobación", description: "El cierre queda con approvalStatus: pending, listo para la revisión (proceso de aprobación)." },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3" },
    { from: "s3", to: "s4", label: "OK" },
    { from: "s3", to: "sErr", label: "con errores" },
    { from: "s4", to: "s5" },
    { from: "s5", to: "s6" },
    { from: "s6", to: "s7", label: "sí" },
    { from: "s6", to: "s8", label: "no" },
    { from: "s7", to: "s8" },
    { from: "s8", to: "s9" },
    { from: "s9", to: "s10" },
    { from: "s10", to: "s11" },
  ],
};

export default cierreMes;
